import { useCallback } from 'react'
import ReactFlow, {
  MiniMap,
  Controls,
  Background,
  useNodesState,
  useEdgesState,
  addEdge,
  type Connection,
  type Edge,
  type Node,
  BackgroundVariant,
} from 'reactflow'
import 'reactflow/dist/style.css'
import { Card, Typography } from 'antd'

const { Text } = Typography

const initialNodes: Node[] = [
  {
    id: '1',
    type: 'input',
    data: { label: 'CSV Upload' },
    position: { x: 250, y: 25 },
    style: { background: '#1890ff', color: 'white', border: '1px solid #1890ff', borderRadius: 8 },
  },
  {
    id: '2',
    data: { label: 'Filter Rows' },
    position: { x: 250, y: 125 },
    style: { background: 'white', border: '2px solid #1890ff', borderRadius: 8 },
  },
  {
    id: '3',
    data: { label: 'Add Calculated Column' },
    position: { x: 250, y: 225 },
    style: { background: 'white', border: '2px solid #722ed1', borderRadius: 8 },
  },
  {
    id: '4',
    type: 'output',
    data: { label: 'Export to JSON' },
    position: { x: 250, y: 325 },
    style: { background: '#52c41a', color: 'white', border: '1px solid #52c41a', borderRadius: 8 },
  },
]

const initialEdges: Edge[] = [
  { id: 'e1-2', source: '1', target: '2', animated: true },
  { id: 'e2-3', source: '2', target: '3', animated: true },
  { id: 'e3-4', source: '3', target: '4', animated: true },
]

export function PipelineBuilder() {
  const [nodes, , onNodesChange] = useNodesState(initialNodes)
  const [edges, setEdges, onEdgesChange] = useEdgesState(initialEdges)

  const onConnect = useCallback(
    (params: Connection | Edge) => setEdges(eds => addEdge(params, eds)),
    [setEdges]
  )

  return (
    <Card
      style={{ height: '600px' }}
      bodyStyle={{ padding: 0, height: '100%' }}
      title={
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <span>Pipeline Canvas</span>
          <Text type="secondary" style={{ fontSize: 14, fontWeight: 'normal' }}>
            Drag nodes to rearrange • Click nodes to configure
          </Text>
        </div>
      }
    >
      <ReactFlow
        nodes={nodes}
        edges={edges}
        onNodesChange={onNodesChange}
        onEdgesChange={onEdgesChange}
        onConnect={onConnect}
        fitView
      >
        <Controls />
        <MiniMap
          nodeColor={(node) => {
            if (node.type === 'input') return '#1890ff'
            if (node.type === 'output') return '#52c41a'
            return '#fff'
          }}
          style={{ backgroundColor: '#f0f2f5' }}
        />
        <Background variant={BackgroundVariant.Dots} gap={12} size={1} />
      </ReactFlow>
    </Card>
  )
}

